import { render, staticRenderFns } from "./LpaRoles.vue?vue&type=template&id=0e0be1a2"
import script from "./LpaRoles.vue?vue&type=script&lang=js"
export * from "./LpaRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports